<template>
  <div>
    <div class="mb-4 d-flex justify-content-between align-items-center">
      <h3>Coupons</h3>
      <div>
        <b-button @click="showAddCouponModal" variant="warning" class="add_button text-white">
          Add Coupon <i class="las la-plus ml-3"></i>
        </b-button>
      </div>
    </div>

    <main-table
      :fields="columns"
      class="mb-0 table-borderless"
      :list_url="'coupons'"
      :reloadData="reloadTable"
    >
      <template v-slot:discount_ratio="data">
        {{ data.data.discount_ratio }}%
      </template>
    <template v-slot:validity_days="data">
      {{data.data.unlimited ? 'Unlimited' : data.data.validity_days }}
    </template>
      <template v-slot:applies_on="data">
        <span v-if="data.data?.applies_on"> All {{ data.data?.applies_on  }}</span>
        <span v-else>
          <span v-for="(data, key) in getAppliedOnData(data.data)" :key="key">
            <span v-if="key !== 0">,</span> {{ data }}
          </span>
        </span>
      </template>
  </main-table>

    <main-modal id="AddCouponModal">
      <template v-slot:header>
          <h4 class="font-weight-bold" v-if="typeOfModal == 'add'"><span class="text-warning" >Add: </span> Coupon</h4>
          <h4 class="font-weight-bold" v-else><span class="text-info" >Edit: </span> Coupon</h4>
      </template>
      <template v-slot:body>
        <CouponForm
          :details="couponDetails"
          @submitForm="addCoupon"
          :typeOfModal="typeOfModal"
          :requestLoading="requestLoading"
        />
      </template>
    </main-modal>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { couponItems } from '../services/data'
import CouponForm from '../components/CouponForm.vue'
import couponsServices from '../services/coupons.services'

export default {

  data () {
    return {
      reloadTable: false,
      requestLoading: false,
      items: couponItems,
      couponDetails: {},
      typeOfModal: 'add',

      columns: [
        { label: '#', key: '#', class: 'text-center', type: 'sort' },
        { label: 'Discount', key: 'discount_ratio', class: 'text-left text-bold', type: 'custom' },
        { label: 'Applies on', key: 'applies_on', class: 'text-left', type: 'custom' },
        { label: 'Validity', key: 'validity_days', class: 'text-left', type: 'custom' },
        {
          label: 'Actions',
          key: 'actions',
          class: 'text-left',
          type: 'actions',
          actions: [
            {
              icon: 'las la-pen',
              color: 'info',
              text: 'Edit',
              actionName: 'showEditCoupon',
              actionParams: 'fullObj'
            },
            {
              icon: 'las la-trash-alt',
              color: 'danger',
              text: 'Delete',
              showAlert: true,
              actionHeader: 'Delete',
              titleHeader: 'Coupon',
              textContent: 'discount_ratio',
              url: 'coupons'
            }
          ]
        }
      ]
    }
  },
  computed: {
    appliedData() {
      return this.getAppliedOnData(this.data.data)
    }
  },
  components: {
    CouponForm
  },

  methods: {
    getAppliedOnData (data)  {
      return [...data.tickets.map(ticket => ticket.name),...data.promotions.map(promotion => promotion.name)]
    },
    showAddCouponModal () {
      this.couponDetails = {}
      this.typeOfModal = 'add'
      this.$bvModal.show('AddCouponModal')
    },

    showEditCoupon (obj) {
      this.typeOfModal = 'edit'
      this.couponDetails = obj
      this.$bvModal.show('AddCouponModal')
    },

    addCoupon (payload) {

      this.requestLoading = true
      this.reloadTable = false

      const obj = {
        discount_ratio: payload.discount,
        unlimited: payload.unlimited,
        applies_on: payload.appliesOn
      }

      if (payload.unlimited == 0) {
        obj.validity_days = payload.validity_days
      }

      if (!payload.appliesOn) {

        obj.tickets = payload.appliesOnGroup
            .filter(item => item.type === 'tickets')
            .map(item => item.value)

        obj.promotions = payload.appliesOnGroup
            .filter(item => item.type === 'promotions')
            .map(item => item.value)

        // تنظيف arrays الفاضية
        if (!obj.tickets.length) delete obj.tickets
        if (!obj.promotions.length) delete obj.promotions
      }

      // edit
      if (this.typeOfModal === 'edit') {

        couponsServices
            .editCoupon(this.couponDetails.id, { ...obj, _method: 'patch' })
            .then(() => {

              this.reloadTable = true
              core.showSnackbar('success', 'Edited Successfully')
              this.$bvModal.hide('AddCouponModal')

            })
            .finally(() => {
              this.requestLoading = false
            })

      } else {

        couponsServices
            .addCoupon(obj)
            .then(() => {

              this.reloadTable = true
              core.showSnackbar('success', 'Added Successfully')
              this.$bvModal.hide('AddCouponModal')

            })
            .finally(() => {
              this.requestLoading = false
            })

      }

    }

  },

  created () {
    this.$root.$on('showEditCoupon', this.showEditCoupon)
  },

  beforeDestroy () {
    this.$root.$off('showEditCoupon')
  },

  mounted () {
    core.index()
  }

}
</script>
